import { render, staticRenderFns } from "./404.vue?vue&type=template&id=dd106d10&scoped=true&"
import script from "./404.js?vue&type=script&lang=js&"
export * from "./404.js?vue&type=script&lang=js&"
import style0 from "./404.scss?vue&type=style&index=0&id=dd106d10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd106d10",
  null
  
)

export default component.exports